import PropertyChecker from "src/embeds/PropertyChecker";

export function PropertyCheckPage() {
  return <PropertyChecker />;
}
